module.exports = __webpack_public_path__ + "static/media/as.e0de4550.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/as.svg
// module id = 858
// module chunks = 0